import { Reducer } from 'interfaces'
import { createAction } from 'helpers/actionHelpers/createAction'
import { Preferences, DEFAULT_PREFERENCES } from 'components/features/preferences/Preferences'

const LOCAL_STORAGE_PREFERENCES_KEY = 'statusMoneyPreferences'

export const GET_PREFERENCES = 'GET_PREFERENCES' as const
export class GetPreferences extends createAction<'GET_PREFERENCES', void>('GET_PREFERENCES') {}

export const SET_PREFERENCES = 'SET_PREFERENCES' as const
export class SetPreferences extends createAction<'SET_PREFERENCES', Partial<Preferences>>('SET_PREFERENCES') {}

export type PreferencesAction = GetPreferences | SetPreferences

export const preferencesReducer: Reducer<Preferences> = (state = DEFAULT_PREFERENCES, action) => {
  switch (action.type) {
    case GET_PREFERENCES:
      const savedPreferences = localStorage.getItem(LOCAL_STORAGE_PREFERENCES_KEY)
      const parsedPreferences = JSON.parse(savedPreferences || 'null')
      return {
        ...state,
        ...parsedPreferences,
      }

    case SET_PREFERENCES: {
      localStorage.setItem(LOCAL_STORAGE_PREFERENCES_KEY, JSON.stringify(action.payload))
      return {
        ...state,
        ...action.payload,
      }
    }

    default:
      return state
  }
}

